import React from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Cancel, Clear, Delete, Edit, Map, Save, GetApp } from '@material-ui/icons';
import { DrawingManager, Marker, Polygon, InfoWindow } from '@react-google-maps/api';
import RegularButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Table from 'components/Table/Table';
import { LayerColorIcon } from 'components/Tvendo/Common/LayerCombo';
import { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { wsCreate, wsGetAll } from 'services/WService';
import CardContainer from '../Common/CardContainer';
import GoogleMapCustom from '../Common/GoogleMapCustom';
import { wsUpdate } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';
import ReactExport from 'react-data-export';
import moment from 'moment';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const routeColors = [
  '#0000ff', // Azul
  '#ffff00', // Amarillo
  '#ff0000', // Rojo
  '#008000', // Verde
  '#800080', // Purple
  '#ffa500', // Naranja
  '#ffc0cb', // Rozado
];

const mesesOptions = [
  { value: '1', text: 'Enero' },
  { value: '2', text: 'Febrero' },
  { value: '3', text: 'Marzo' },
  { value: '4', text: 'Abril' },
  { value: '5', text: 'Mayo' },
  { value: '6', text: 'Junio' },
  { value: '7', text: 'Julio' },
  { value: '8', text: 'Agosto' },
  { value: '9', text: 'Septiembre' },
  { value: '10', text: 'Octubre' },
  { value: '11', text: 'Noviembre' },
  { value: '12', text: 'Diciembre' },
];

const daysOptions = [
  { value: 'ALL', text: 'Todos', days: ['2','3','4','5','6','7','8'] },
  { value: '2', text: 'Lunes' },
  { value: '3', text: 'Martes' },
  { value: '4', text: 'Miércoles' },
  { value: '5', text: 'Jueves' },
  { value: '6', text: 'Viernes' },
  { value: '7', text: 'Sábado' },
  { value: '8', text: 'Domingo' },
];


const mapHeight = '540px';

function RouteSales() {
  const [mapCenter, setMapCenter] = useState({
    lat: -14.07543457346045,
    lng: -75.73423487506565,
  });
  const [processing, setProcessing] = useState(false);
  const [editing, setEditing] = useState(false);
  const [editingRouteIds, setEditingRouteIds] = useState([]);
  const editingPolRef = useRef([]);
  const editingPolListenerRef = useRef([]);
  const [currentId, setCurrentId] = useState(0);
  const [mapZoom] = useState(14);
  const [zones, setZones] = useState([]);
  const [divitions, setDivitions] = useState([]);
  const [layers, setLayers] = useState([]);
  const [zoneId, setZoneId] = useState('');
  const [divitionId, setDivitionId] = useState('');
  const [layerId, setLayerId] = useState('');
  const [portfolios, setPortfolios] = useState([]);
  const [portfolioId, setPortfolioId] = useState('');
  const [meses, setMeses] = useState('3');
  const [currentMonths, setCurrentMonths] = useState('3');
  const [routes, setRoutes] = useState([]);
  const [selectedRoutes, setSelectedRoutes] = useState([]);
  const [drawedPolygons, setDrawedPolygons] = useState([]);
  const [currentDrawedPolygon, setCurrentDrawedPolygon] = useState(undefined);
  const [showMarkers, setShowMarkers] = useState(true);
  const [routeInfo, setRouteInfo] = useState({ show: false, lat: null, lng: null, title: '', description: '', data: null });
  const [clientInfo, setClientInfo] = useState({ show: false, lat: null, lng: null, data: null });
  const [aniosOptions, setAniosOptions] = useState([]);
  const [aniosLength, setAniosLength] = useState(1);
  const [mesesLength, setMesesLength] = useState(0);

  async function loadData() {
    const [zoneRes, divitionRes] = await Promise.all([
      wsGetAll('base/zone'),
      wsGetAll('base/layer-divition'),
    ]);
    if (zoneRes.success) {
      setZones(zoneRes.data);
      setZoneId(zoneRes.data[1].id);
    }
    if (divitionRes.success) {
      setDivitions(divitionRes.data);
      setDivitionId(divitionRes.data[0].id);
      loadLayers(divitionRes.data[0].id);
    }
  }
// console.log('ID DE DIA SELECCIONADO:', daysSeleccionados);
  async function loadRoutes() {

    if (anios.length === 0) {
      window.alert('Seleccione al menos un año');
      return;
    }
    console.log('daysSeleccionados:', daysSeleccionados);
    setProcessing(true);
    setRoutes([]);
    setCurrentMonths(meses);
    // Limpiar selección de rutas/polígonos al cargar nuevos datos
    setSelectedRoutes([]);
    setEditingRouteIds([]);
    setEditing(false);
    if (editingPolListenerRef.current.length > 0) {
      editingPolListenerRef.current.forEach((lis) => lis.remove());
      editingPolListenerRef.current = [];
    }
    editingPolRef.current = [];
    const params = new URLSearchParams();
    for (let anio of anios) {
      params.append('years[]', anio);
    }
    for (let mes of mesesSeleccionados) {
      params.append('months[]', mes);
    }
    for (let day of daysSeleccionados) {
      if (day !== 'ALL') {
        params.append('days[]', day);
      }
    }
    setMesesLength(mesesSeleccionados.length);
    setAniosLength(anios.length);
    const res = await wsGetAll(
      `report/route-sales?base_zone_id=${zoneId}&divition_id=${divitionId}&base_layer_id=${layerId}&base_portfolio_id=${portfolioId}&${params.toString()}`,
    );
    setProcessing(false);
    if (res.success) {
      if (res.data.length > 0) {
        let geometry = undefined;
        for (let route of res.data) {
          if (route.geometry !== null) {
            geometry = route.geometry;
            break;
          }
        }
        if (geometry !== undefined) {
          setMapCenter({
            lat: geometry[0].lat,
            lng: geometry[0].lng,
          });
        }
      }
      setRoutes(res.data);
    }
  }

  async function loadLayers(divitionId) {
    const res = await wsGetAll(`base/layer?divition_id=${divitionId}`);
    if (res.success) {
      setLayers(res.data);
      if (res.data.length > 0) {
        setLayerId(res.data[3]?.id);
      }
    }
  }

  async function loadPortfolios(divitionId) {
    const res = await wsGetAll(`base/customer-portfolio?divition_id=${divitionId}&base_zone_id=${zoneId}&deleted_at=null&state=A`);
    if (res.success) {
      setPortfolios(res.data);
      if (res.data.length > 0) {
        setPortfolioId(res.data[0].id);
      }
    }
  }

  function onZoneChange(e) {
    setZoneId(e.target.value);
    // Limpiar rutas seleccionadas cuando cambien parámetros
    setSelectedRoutes([]);
    setDrawedPolygons([]);
  }

  function onDivitionChange(e) {
    setDivitionId(e.target.value);
    loadLayers(e.target.value);
    // Limpiar rutas seleccionadas cuando cambien parámetros
    setSelectedRoutes([]);
    setDrawedPolygons([]);
  }
  
  useEffect(() => {
    // if (processing) return;
    if (!zoneId && !divitionId) return;

    loadPortfolios(divitionId, zoneId);
  }, [zoneId, divitionId]);



  function onLayerChange(e) {
    setLayerId(e.target.value);
    // Limpiar rutas seleccionadas cuando cambien parámetros
    setSelectedRoutes([]);
    setDrawedPolygons([]);
  }
  
  function onPortfolioChange(id) {
    setPortfolioId(id);
    // Limpiar rutas seleccionadas cuando cambien parámetros
    setSelectedRoutes([]);
    setDrawedPolygons([]);
  }


  function getNextColor() {
    const currentColors = selectedRoutes.map((item) => item.color);
    let nextColor = '';
    for (let color of routeColors) {
      if (!currentColors.includes(color)) {
        nextColor = color;
        break;
      }
    }
    return nextColor;
  }

  function onPolygonComplete(polygon) {
    if (currentDrawedPolygon) {
      polygon.setMap(null);
      window.alert('Complete el poligono antes de hacer otro');
      return;
    }
    let coords = polygon.getPath().getArray();
    if (coords.length < 3) {
      polygon.setMap(null);
      return;
    }
    coords = coords.map((point) => {
      return {
        lat: point.lat(),
        lng: point.lng(),
      };
    });
    polygon.setMap(null);
    setProcessing(true);
    setCurrentDrawedPolygon(coords);

    setTimeout(() => {
      setProcessing(false);
    }, 1000);
  }

  async function guardarEditados() {
    setProcessing(true);
    const routes = editingPolRef.current
      .filter((it) => {
        return editingRouteIds.includes(it.id);
      })
      .map((it) => {
        let points = it.polygon
          .getPath()
          .getArray()
          .map((latLng) => {
            return { lat: latLng.lat(), lng: latLng.lng() };
          });

        if (
          points[0].lat !== points[points.length - 1].lng &&
          points[0].lat !== points[points.length - 1].lng
        ) {
          points.push(points[0]);
        }
        return {
          id: it.id,
          points,
        };
      });

    const res = await wsUpdate('base/route/update-multiple-poligons', {
      base_layer_id: layerId,
      routes,
    });
    setProcessing(false);
    if (res.success) {
      alert(res.message);
      setEditing(false);
      setEditingRouteIds([]);
    } else {
      alert(res.message);
    }
  }

  function onRoutePoligonLoad(polygon, route) {
    editingPolRef.current.push({ polygon, id: route.id });
  }

  function startEdit() {
    setEditing(true);
    setDrawedPolygons([]);
    setSelectedRoutes([]);
  }

  function endEdit() {
    setEditing(false);
    setEditingRouteIds([]);
    loadRoutes();
  }

  const draggingRef = useRef(false);
  const polygonRef = useRef(null);
  const polygonRefs = useRef([]);

  async function saveDrawedPolygon() {
    setProcessing(true);
    const nextPath = polygonRef.current
      .getPath()
      .getArray()
      .map((latLng) => {
        return { lat: latLng.lat(), lng: latLng.lng() };
      });

    const years = [];
    const months = [];
    for (let anio of anios) {
      years.push(anio);
    }
    for (let mes of mesesSeleccionados) {
      months.push(mes);
    }

    // TODO dsf
    const res = await wsCreate(`report/route-sales`, {
      base_zone_id: zoneId,
      divition_id: divitionId,
      base_layer_id: layerId,
      months,
      years,
      points: nextPath,
    });
    setProcessing(false);

    if (res.success) {
      setCurrentDrawedPolygon(undefined);
      setDrawedPolygons((polygons) => {
        let newPolygons = [...polygons];
        newPolygons.push({
          _id: currentId,
          geometry: nextPath,
          addresses: res.data.addresses,
          data: res.data.data[0],
          data_bureau: res.data?.data_bureau,
        });
        setCurrentId((id) => id + 1);
        return newPolygons;
      });
      onUnmount();
    }
  }

  function deleteDrawedPolygon() {
    if (!window.confirm('Eliminar el poligono actual?')) return;
    setCurrentDrawedPolygon(undefined);
    onUnmount();
  }

  const onEdit = useCallback(() => {
    if (draggingRef.current) return;
    if (polygonRef.current) {
      const nextPath = polygonRef.current
        .getPath()
        .getArray()
        .map((latLng) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
      setCurrentDrawedPolygon(nextPath);
    }
  }, []);

  const onPolygonLoad = useCallback(
    (polygon) => {
      polygonRef.current = polygon;
      const path = polygon.getPath();
      polygonRefs.current.push(
        path.addListener('set_at', onEdit),
        path.addListener('insert_at', onEdit),
        path.addListener('remove_at', onEdit),
      );
    },
    [onEdit],
  );

  const onDragStart = useCallback(() => {
    draggingRef.current = true;
  }, []);

  const onDragEnd = useCallback(() => {
    draggingRef.current = false;
    if (polygonRef.current) {
      const nextPath = polygonRef.current
        .getPath()
        .getArray()
        .map((latLng) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
      setCurrentDrawedPolygon(nextPath);
    }
  }, []);

  const onUnmount = useCallback(() => {
    polygonRefs.current.forEach((lis) => lis.remove());
    polygonRef.current = null;
  }, []);
  
  const [anios, setAnios] = useState([]);
  const [mesesSeleccionados, setMesesSeleccionados] = useState([]);
  const [daysSeleccionados, setDaysSeleccionados] = useState([]);
  const [days, setDays] = useState([]);
  const [showMonthlyBreakdown, setShowMonthlyBreakdown] = useState(false);
  const yearCount = anios.length;
  const monthCount = mesesSeleccionados.length;
  const shouldShowDetailedCards = yearCount > 1 || monthCount > 1;

  function getRouteVisitDayIds(route) {
    const ids = new Set();
    const inspectArray = (arr) => {
      if (!Array.isArray(arr)) return;
      arr.forEach((it) => {
        if (it && it.base_visit_day_id) ids.add(String(it.base_visit_day_id));
      });
    };

    if (route.data && Array.isArray(route.data)) inspectArray(route.data);
    if (route.data && !Array.isArray(route.data) && route.data.base_visit_day_id) ids.add(String(route.data.base_visit_day_id));
    Object.keys(route).forEach((k) => {
      if (/^data\d{4}/.test(k) && Array.isArray(route[k])) {
        inspectArray(route[k]);
      }
      if (/^data\d{4}/.test(k) && route[k] && !Array.isArray(route[k]) && route[k].base_visit_day_id) {
        ids.add(String(route[k].base_visit_day_id));
      }
    });

    return Array.from(ids);
  }

  function routeHasDataWithoutDay(route) {
    if (!route) return false;
    if (route.data && !Array.isArray(route.data) && Object.keys(route.data).length > 0) {
      return !route.data.base_visit_day_id;
    }
    const keys = Object.keys(route).filter((k) => /^data\d{4}/.test(k));
    for (let k of keys) {
      const v = route[k];
      if (!v) continue;
      if (!Array.isArray(v) && typeof v === 'object' && Object.keys(v).length > 0) {
        if (!v.base_visit_day_id) return true;
      }
      if (Array.isArray(v)) {
        if (v.some((it) => it && !it.base_visit_day_id && (it.total_pedidos || it.total_migrate || it.total_clientes))) return true;
      }
    }
    return false;
  }

  const visitDayColorMap = React.useMemo(() => {
    const map = {};
    daysOptions.forEach((opt, idx) => {
      map[opt.value] = routeColors[idx % routeColors.length];
    });
    return map;
  }, []);

  useEffect(() => {
    loadData();
    let year = (new Date()).getFullYear();
    let years = [];
    while (year >= 2023) {
      years.push(year.toString());
      year--;
    }
    // years = years.reverse();
    setAniosOptions(years);
    setAnios([years[0]]);
  }, []);

  function handleChange(e) {
    setAnios(e.target.value);
    // Limpiar rutas seleccionadas cuando cambien los años
    setSelectedRoutes([]);
    setDrawedPolygons([]);
  }

  function handleMesChange(e) {
    setMesesSeleccionados(e.target.value);
    // Limpiar rutas seleccionadas cuando cambien los meses
    setSelectedRoutes([]);
    setDrawedPolygons([]);
  }
  const handleDayChange = (event) => {
    const value = event.target.value;

    if (value.includes('ALL')) {
      // Si selecciona "Todos"
      const allDays = daysOptions
        .find((d) => d.value === 'ALL')
        .days;

      setDaysSeleccionados(['ALL', ...allDays]);
    } else {
      // Si quita "Todos"
      setDaysSeleccionados(value.filter((v) => v !== 'ALL'));
    }
    
    // Limpiar rutas seleccionadas cuando cambien los días
    setSelectedRoutes([]);
    setDrawedPolygons([]);
  };


  const combinedRoutesForAvg = selectedRoutes.map((r) => ({ data: r.data }));
  const routeCount = combinedRoutesForAvg.length;
  const totalPedidosAll = combinedRoutesForAvg.reduce(
    (s, r) => s + (parseFloat(r.data?.total_pedidos) || 0),
    0,
  );
  const totalClientesAll = combinedRoutesForAvg.reduce(
    (s, r) => s + (parseFloat(r.data?.total_clientes) || 0),
    0,
  );
  const totalMontoAll = combinedRoutesForAvg.reduce(
    (s, r) => s + (parseFloat(r.data?.total_migrate) || 0),
    0,
  );
  const avgPedidosAll = routeCount > 0 ? totalPedidosAll / routeCount : 0;
  const avgClientesAll = routeCount > 0 ? totalClientesAll / routeCount : 0;
  const avgMontoAll = routeCount > 0 ? totalMontoAll / routeCount : 0;

  const bureauMap = {};
  const combinedRoutesFull = [...selectedRoutes];
  combinedRoutesFull.forEach((r) => {
    const list = r.data_bureau || r.data?.data_bureau || [];
    (list || []).forEach((b) => {
      const key = b.bureau_description || b.description || b.id || 'unknown';
      if (!bureauMap[key]) {
        bureauMap[key] = {
          description: key,
          total_pedidos: 0,
          total_clientes: 0,
          total_migrate: 0,
        };
      }
      bureauMap[key].total_pedidos += parseFloat(b.total_pedidos) || 0;
      bureauMap[key].total_clientes += parseFloat(b.total_clientes) || 0;
      bureauMap[key].total_migrate += parseFloat(b.total_migrate) || 0;
    });
  });

  const bureauList = Object.values(bureauMap).map((b) => {
    return {
      description: b.description,
      avg_pedidos: routeCount > 0 ? b.total_pedidos / routeCount : 0,
      avg_clientes: routeCount > 0 ? b.total_clientes / routeCount : 0,
      avg_monto: routeCount > 0 ? b.total_migrate / routeCount : 0,
      total_pedidos: b.total_pedidos,
      total_clientes: b.total_clientes,
      total_migrate: b.total_migrate,
    };
  });

  // Función para exportar clientes de una mesa a Excel
  function exportBureauClientsToExcel(bureauData, routeName, bureauName, monthYear = '') {
    if (!bureauData.clients || bureauData.clients.length === 0) {
      window.alert('No hay clientes para exportar en esta mesa');
      return;
    }

    const filename = `${routeName}_${bureauName}${monthYear ? '_' + monthYear : ''}_${moment().format('DD-MM-YYYY')}`;
    
    // Transformar datos de clientes en formato de array de arrays (como ReactTable)
    const clientsData = bureauData.clients.map((client, index) => [
      {
        value: index + 1,
        style: {
          border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
          },
        },
      },
      {
        value: client.CardCode,
        style: {
          border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
          },
        },
      },
      {
        value: client.CardName,
        style: {
          border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
          },
        },
      },
      {
        value: client.total_pedidos,
        style: {
          border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
          },
        },
      },
      {
        value: parseFloat(client.total_migrate).toFixed(2),
        style: {
          border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
          },
        },
      },
    ]);

    return (
      <ExcelFile element={<RegularButton size="sm" color="success"><GetApp /></RegularButton>} filename={filename}>
        <ExcelSheet
          dataSet={[
            {
              columns: [
                { title: '#', width: { wch: 5 } },
                { title: 'Código', width: { wch: 15 } },
                { title: 'Nombre', width: { wch: 35 } },
                { title: 'N° Pedidos', width: { wch: 12 } },
                { title: 'Monto S/.', width: { wch: 15 } },
              ],
              data: clientsData,
            },
          ]}
          name="Clientes"
        />
      </ExcelFile>
    );
  }

  return (
    <Fragment>
      <CardContainer title="Mapa" icon={<Map />}>
        <GridContainer>
          <GridItem xs={12}>
            <GridContainer>
              {/* Zona */}
              <GridItem xs={2}>
                <FormControl fullWidth margin="normal">
                  <InputLabel shrink>Zona</InputLabel>
                  <Select value={zoneId} fullWidth onChange={onZoneChange} disabled={processing}>
                    {zones.map((zone) => {
                      return (
                        <MenuItem key={zone.id} value={zone.id}>
                          {zone.description}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              {/* División */}
              <GridItem xs={2}>
                <FormControl fullWidth margin="normal">
                  <InputLabel shrink>División</InputLabel>
                  <Select
                    value={divitionId}
                    fullWidth
                    onChange={onDivitionChange}
                    disabled={processing}
                  >
                    {divitions.map((divition) => {
                      return (
                        <MenuItem key={divition.id} value={divition.id}>
                          {divition.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              {/* Años */}
              <GridItem xs={2}>
                <FormControl fullWidth margin="normal">
                  <InputLabel shrink>Años</InputLabel>
                  <Select
                    fullWidth
                    multiple
                    value={anios}
                    renderValue={(selected) => selected.join(', ')}
                    onChange={handleChange}
                    disabled={processing}
                  >
                    {aniosOptions.map((option) => {
                      return (
                        <MenuItem value={option} key={option}>
                          <Checkbox checked={anios.includes(option)} />
                          <ListItemText primary={option} />
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              {/* Meses */}
              <GridItem xs={2}>
                <FormControl fullWidth margin="normal">
                  <InputLabel shrink>Meses</InputLabel>
                  <Select
                    renderValue={(selected) => {
                      let meses = mesesOptions
                        .filter((item) => selected.includes(item.value))
                        .map((item) => item.text);
                      return meses.join(', ');
                    }}
                    placeholder="Seleccionar"
                    value={mesesSeleccionados}
                    onChange={handleMesChange}
                    disabled={processing}
                    fullWidth
                    multiple
                  >
                    {mesesOptions.map((option) => {
                      return (
                        <MenuItem value={option.value} key={option.value}>
                          <Checkbox checked={mesesSeleccionados.includes(option.value)} />
                          <ListItemText primary={option.text} />
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              {/* Dias semana */}
              <GridItem xs={2}>
                <FormControl fullWidth margin="normal">
                  <InputLabel shrink>Días Semana</InputLabel>
                  <Select
                    multiple
                    value={daysSeleccionados}
                    onChange={handleDayChange}
                    disabled={processing}
                    renderValue={(selected) => {
                      if (selected.includes('ALL')) return 'Todos';

                      return daysOptions
                        .filter((item) => selected.includes(item.value))
                        .map((item) => item.text)
                        .join(', ');
                    }}
                  >
                    {daysOptions.map((option) => (
                      // <MenuItem value={option.value} key={option.value}>
                      //   <Checkbox checked={daysSeleccionados.includes(option.value)} />
                      //   <ListItemText primary={option.text} />
                      // </MenuItem>
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        disabled={
                          daysSeleccionados.includes('ALL') &&
                          option.value !== 'ALL'
                        }
                      >
                        <Checkbox checked={daysSeleccionados.includes(option.value)} />
                        <ListItemText primary={option.text} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </GridItem>
              {/* Capas/Layers */}
              <GridItem xs={2}>
                <FormControl fullWidth margin="normal">
                  <InputLabel shrink>Capas</InputLabel>
                  <Select value={layerId} fullWidth onChange={onLayerChange} disabled={processing}>
                    {layers.map((layer) => {
                      return (
                        <MenuItem key={layer.id} value={layer.id}>
                          {layer.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              {/* portafolios */}
              <GridItem xs={2}>
                {/* <FormControl fullWidth margin="normal">
                  <InputLabel shrink>Portafolios</InputLabel>
                  <Select value={portfolioId} fullWidth onChange={onPortfolioChange} disabled={processing}>
                    {portfolios.map((portfolio) => {
                      return (
                        <MenuItem key={portfolio.id} value={portfolio.id}>
                          {portfolio.description}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl> */}
                {/* <Autocomplete

                  disableClearable
                  options={portfolioId}
                  getOptionLabel={(item) => `${item.description}`}
                  renderInput={(params) => (
                    <TextField {...params} label="Portafolios" margin="normal" fullWidth />
                  )}
                  onChange={(e, item) => {handleChange('base_customer_portfolio_id', item?.id); setDataImport(null);}}
                  value={portfolioId.find((ptf) => ptf.id === dataChanging.base_customer_portfolio_id) || null}
                  style={{ flexGrow: 1, marginRight: '10px' }}
                /> */}
                {/* <Autocomplete
                  disableClearable
                  options={portfolios}
                  getOptionLabel={(option) => option.description}
                  value={portfolios.find((ptf) => ptf.id === portfolioId) || null}
                  onChange={(e, item) => onPortfolioChange(item?.id)}
                  renderInput={(params) => (
                    <TextField {...params} label="Portafolios" margin="normal" fullWidth />
                  )}
                  disabled={processing}
                /> */}
                <Autocomplete
                  disableClearable
                  options={portfolios}
                  getOptionLabel={(option) => option.description}
                  value={portfolios.find((ptf) => ptf.id === portfolioId) || null}
                  onChange={(e, item) => onPortfolioChange(item?.id)}
                  renderInput={(params) => (
                    <TextField {...params} label="Portafolios" margin="normal" fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {!!portfolioId && !processing && (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  aria-label="Limpiar portafolio"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onPortfolioChange(null);
                                  }}
                                >
                                  <Clear fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            )}

                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  disabled={processing}
                />

              </GridItem>
              <GridItem xs={2}>
                <FormControlLabel
                  label="Mostrar direcciones"
                  control={
                    <Checkbox
                      margin="normal"
                      disabled={processing}
                      checked={showMarkers}
                      onChange={() => setShowMarkers((show) => !show)}
                    />
                  }
                />
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12}>
            <GridContainer>
              {/* Buscar */}
              <GridItem xs={2}>
                {!editing ? (
                  <Fragment>
                    <RegularButton color="success" onClick={loadRoutes} disabled={processing}>
                      Buscar
                    </RegularButton>
                    {/* Editar */}
                    <RegularButton round justIcon color="warning" onClick={startEdit}>
                      <Edit />
                    </RegularButton>
                  </Fragment>
                ) : (
                  <Fragment>
                    <RegularButton color="success" onClick={guardarEditados}>
                      Guardar
                    </RegularButton>
                    {/* Editar */}
                    <RegularButton round justIcon color="danger" onClick={endEdit}>
                      <Cancel />
                    </RegularButton>
                  </Fragment>
                )}
              </GridItem>
              <GridItem xs={4} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                  <strong>Leyenda:</strong>
                  {daysOptions.map((opt, idx) => {
                    const color = visitDayColorMap[opt.value] || routeColors[idx % routeColors.length];
                    return (
                      <div key={opt.value} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <span
                          style={{
                            width: '14px',
                            height: '14px',
                            borderRadius: '50%',
                            display: 'inline-block',
                            backgroundColor: color,
                            border: '1px solid #ffffff66',
                          }}
                        />
                        <span style={{ fontSize: '13px' }}>{opt.text}</span>
                      </div>
                    );
                  })}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span
                      style={{
                        width: '14px',
                        height: '14px',
                        borderRadius: '50%',
                        display: 'inline-block',
                        backgroundColor: '#BFEFFF',
                        border: '2px solid #000000',
                      }}
                    />
                    <span style={{ fontSize: '13px' }}>Más de 1 día de visita</span>
                  </div>
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12}>
            {processing && (
              <div
                style={{
                  width: '100%',
                  height: mapHeight,
                  minHeight: '500px',
                  backgroundColor: '#0000008a',
                  position: 'absolute',
                  zIndex: 100,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    display: 'block',
                    fontSize: '40px',
                    width: '100%',
                    textAlign: 'center',
                    color: 'white',
                  }}
                >
                  Procesando...
                </span>
              </div>
            )}
            {currentDrawedPolygon !== undefined && (
              <div style={{ position: 'absolute', top: '185px', right: '17px', zIndex: 90 }}>
                <RegularButton justIcon round size="sm" color="success" onClick={saveDrawedPolygon}>
                  <Save />
                </RegularButton>
                <RegularButton
                  justIcon
                  round
                  size="sm"
                  color="danger"
                  onClick={deleteDrawedPolygon}
                >
                  <Delete />
                </RegularButton>
              </div>
            )}
            <GoogleMapCustom
              mapContainerStyle={{
                width: '100%',
                height: mapHeight,
              }}
              zoom={mapZoom}
              center={mapCenter}
              options={{
                disableDoubleClickZoom: true,
              }}
            >
              {editing === false && (
                <DrawingManager
                  onPolygonComplete={onPolygonComplete}
                  drawingMode="polygon"
                  options={{
                    drawingControlOptions: {
                      position: 7,
                      drawingModes: ['polygon'],
                    },
                  }}
                />
              )}
              {/* Poligonos para seleccionar pedidos */}
              {drawedPolygons.map((polygon, i) => {
                return (
                  <Polygon
                    visible={currentDrawedPolygon?._id !== polygon._id}
                    key={polygon._id}
                    path={polygon.geometry}
                    options={{ fillColor: '#ff5733' }}
                    onDblClick={() => {
                      if (window.confirm('Eliminar el poligono seleccionado ?')) {
                        setDrawedPolygons((polygons) => {
                          let newPolygons = [...polygons];
                          newPolygons.splice(i, 1);
                          return newPolygons;
                        });
                      }
                    }}
                  />
                );
              })}
              {/* Poligono actual */}
              {currentDrawedPolygon !== undefined && (
                <Polygon
                  editable={true}
                  draggable={true}
                  onDragStart={onDragStart}
                  onDragEnd={onDragEnd}
                  path={currentDrawedPolygon}
                  onLoad={onPolygonLoad}
                  options={{ fillColor: '#ff5733' }}
                  onDblClick={() => {
                    if (!window.confirm('Eliminar el poligono seleccionado ?')) return;
                    setCurrentDrawedPolygon(undefined);
                  }}
                  // onUnmount={onUnmount}
                />
              )}
              {routes.map((item) => {
                if (item.geometry === null) return undefined;
                const selectedRoute = selectedRoutes.find((r) => r.id === item.id);

                const visitDayIds = getRouteVisitDayIds(item);

                const hasDataNoDay = routeHasDataWithoutDay(item);

                if (daysSeleccionados && daysSeleccionados.length > 0) {
                  if (!visitDayIds || visitDayIds.length === 0) return undefined;
                  const intersects = visitDayIds.some((id) => daysSeleccionados.includes(id));
                  if (!intersects) return undefined;
                }

                const isMultiVisit = visitDayIds.length > 1;

                const isNoData = (!visitDayIds || visitDayIds.length === 0) && !hasDataNoDay;

                let baseColor = null;
                let strokeColor = null;
                let fillOpacity = isMultiVisit ? 0.6 : 0.45;

                if (editingRouteIds.includes(item.id)) {
                  baseColor = '#F0FF00';
                } else if (selectedRoute?.color) {
                  baseColor = selectedRoute.color;
                } else if (isMultiVisit) {
                  baseColor = '#BFEFFF';
                  strokeColor = '#000000';
                } else if (visitDayIds.length > 0) {
                  baseColor = visitDayColorMap[visitDayIds[0]] || routeColors[Number(item.id) % routeColors.length];
                  strokeColor = baseColor;
                } else if (hasDataNoDay) {
                  baseColor = '#666666';
                } else if (isNoData) {
                  baseColor = '#666666';
                } else {
                  const idNum = parseInt(item.id, 10);
                  baseColor = isNaN(idNum) ? routeColors[0] : routeColors[idNum % routeColors.length];
                }
                const polygonOptions = {
                  fillColor: baseColor,
                  fillOpacity,
                  strokeColor,
                };

                const getCentroid = (coords) => {
                  if (!coords || coords.length === 0) return null;
                  let sx = 0;
                  let sy = 0;
                  coords.forEach((c) => {
                    sx += parseFloat(c.lat) || 0;
                    sy += parseFloat(c.lng) || 0;
                  });
                  return { lat: sx / coords.length, lng: sy / coords.length };
                };

                return (
                  <Fragment key={item.id}>
                    <Polygon
                      editable={processing ? false : editingRouteIds.includes(item.id)}
                      draggable={processing ? false : editingRouteIds.includes(item.id)}
                      onDblClick={() => {
                        if (processing) return;
                        if (editing === false) return;

                        setEditingRouteIds((ids) => {
                          let newIds = [...ids];
                          newIds.push(item.id);
                          return newIds;
                        });
                      }}
                      onClick={() => {
                        if (processing) return;
                        if (editing === true) return;
                        const c = getCentroid(item.geometry || []);
                        setRouteInfo({
                          show: true,
                          lat: c?.lat || (item.geometry[0]?.lat),
                          lng: c?.lng || (item.geometry[0]?.lng),
                          title: item.code + ' - ' + item.description,
                          description: `Pedidos: ${item.data?.total_pedidos || 0} \nClientes: ${item.data?.total_clientes || 0} \nMonto: S/. ${parseFloat(item.data?.total_migrate || 0).toFixed(2)}`,
                          data: item,
                        });

                        setSelectedRoutes((items) => {
                          const newRoutes = [...items];
                          if (selectedRoute === undefined) {
                            if (items.length === routeColors.length) return newRoutes;
                            newRoutes.push({ ...item, color: getNextColor() });
                          } else {
                            const index = newRoutes.findIndex((r) => r.id === item.id);
                            newRoutes.splice(index, 1);
                          }
                          return newRoutes;
                        });
                      }}
                      onLoad={(polygon) => onRoutePoligonLoad(polygon, item)}
                      paths={item.geometry}
                      options={polygonOptions}
                    />
                    {/* Direcciones */}
                    {showMarkers &&
                      item.addresses.map((address) => {
                        return (
                          <Marker
                            key={address.id}
                            position={{
                              lat: parseFloat(address.latitude),
                              lng: parseFloat(address.longitude),
                            }}
                            onClick={() => {
                              const lat = parseFloat(address.latitude);
                              const lng = parseFloat(address.longitude);
                              if (!isNaN(lat) && !isNaN(lng)) {
                                setClientInfo({ show: true, lat, lng, data: address });
                                setRouteInfo((r) => ({ ...r, show: false }));
                              }
                            }}
                          />
                        );
                      })}
                    {routeInfo.show && routeInfo.lat !== null && routeInfo.lng !== null && routeInfo.data?.id === item.id && (
                      <InfoWindow
                        position={{ lat: Number(routeInfo.lat), lng: Number(routeInfo.lng) }}
                        onCloseClick={() => setRouteInfo({ show: false, title: '', description: '' })}
                        options={{
                          pixelOffset: {
                            width: 0,
                            height: -25,
                          },
                        }}
                      >
                        <div>
                          <h4>{routeInfo.title}</h4>
                          <p>{routeInfo.description}</p>
                        </div>
                      </InfoWindow>
                    )}
                    {clientInfo.show && clientInfo.lat !== null && clientInfo.lng !== null && (
                      <InfoWindow
                        position={{ lat: Number(clientInfo.lat), lng: Number(clientInfo.lng) }}
                        onCloseClick={() => setClientInfo({ show: false, lat: null, lng: null, data: null })}
                      >
                        <div>
                          <h4>{clientInfo.data?.CardCode + ' - ' + clientInfo.data?.CardName || 'Cliente'}</h4>
                        </div>
                      </InfoWindow>
                    )}
                  </Fragment>
                );
              })}
            </GoogleMapCustom>
          </GridItem>
        </GridContainer>
      </CardContainer>
      <CardContainer title="Rutas seleccionadas" icon={null}>
        <GridContainer>
          <GridItem xs={12}>
            {selectedRoutes.length === 0 && drawedPolygons.length === 0 ? (
              <div
                style={{
                  display: 'flex',
                  height: '100%',
                  flexDirection: 'row',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <h3 style={{ textAlign: 'center', width: '100%' }}>Seleccione una ruta</h3>
              </div>
            ) : (
              <>
                <div style={{ width: '100%', padding: '10px 0' }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showMonthlyBreakdown}
                        onChange={(e) => setShowMonthlyBreakdown(e.target.checked)}
                        disabled={!shouldShowDetailedCards}
                        color="primary"
                      />
                    }
                    label="Mostrar información por año/mes"
                  />
                </div>

                <GridContainer>
                  <GridItem xs={12} md={4} lg={4} style={{ padding: '20px' }}>
                    <span>N° Pedidos</span>
                    <p>{avgPedidosAll}</p>

                    <span>N° Clientes</span>
                    <p>{avgClientesAll}</p>

                    <span>Monto S/.</span>
                    <p>S/. {avgMontoAll.toFixed(2)}</p>
                  </GridItem>

                  <GridItem xs={12}>
                    <div>
                      <Table
                        tableHead={['#', 'Mesa', 'N° Pedidos', 'N° Clientes', 'Monto S/.']}

                        tableData={bureauList.map((b, index) => {
                          return [
                            index + 1,
                            b.description,
                            b.avg_pedidos ,
                            b.avg_clientes ,
                            'S/.' + b.avg_monto.toFixed(2),
                          ];
                        })}
                      />
                    </div>
                  </GridItem>

                {drawedPolygons.map((drawedRoute, i) => {
                  return (
                    <GridItem
                      key={drawedRoute._id}
                      xs={4}
                      style={{ padding: '30px', position: 'relative' }}
                    >
                      <div style={{ position: 'absolute', top: '25px', right: '20px' }}>
                        <RegularButton
                          justIcon
                          round
                          color="danger"
                          onClick={() => {
                            setDrawedPolygons((items) => {

                              const newRoutes = [...items];
                              newRoutes.splice(i, 1);
                              return newRoutes;
                            });
                          }}
                        >
                          <Delete />
                        </RegularButton>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                        <h4>Ruta dibujada {drawedRoute._id + 1}</h4>
                        <LayerColorIcon
                          layer={{ color: '#ff5733' }}
                          style={{ marginLeft: '10px' }}
                        />
                      </div>

                      <span>N° Pedidos</span>
                      <p>{drawedRoute.data?.total_pedidos}</p>

                      <span>N° Clientes</span>
                      <p>{drawedRoute.data?.total_clientes}</p>

                      <span>Monto S/.</span>
                      <p>S/. {parseFloat(drawedRoute.data?.total_migrate).toFixed(2)}</p>

                      <div>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
                          <thead>
                            <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
                              <th style={{ padding: '8px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>#</th>
                              <th style={{ padding: '8px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>Mesa</th>
                              <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>N° Pedidos</th>
                              <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>N° Clientes</th>
                              <th style={{ padding: '8px', textAlign: 'right', fontSize: '12px', fontWeight: 'bold' }}>Monto S/.</th>
                              <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>Exportar</th>
                            </tr>
                          </thead>
                          <tbody>
                            {drawedRoute.data_bureau.map((dataBureau, index) => (
                              <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                <td style={{ padding: '8px', textAlign: 'left', fontSize: '12px' }}>{index + 1}</td>
                                <td style={{ padding: '8px', textAlign: 'left', fontSize: '12px' }}>{dataBureau.bureau_description}</td>
                                <td style={{ padding: '8px', textAlign: 'center', fontSize: '12px' }}>{dataBureau.total_pedidos}</td>
                                <td style={{ padding: '8px', textAlign: 'center', fontSize: '12px' }}>{dataBureau.total_clientes}</td>
                                <td style={{ padding: '8px', textAlign: 'right', fontSize: '12px' }}>S/. {parseFloat(dataBureau.total_migrate).toFixed(2)}</td>
                                <td style={{ padding: '8px', textAlign: 'center' }}>
                                  {dataBureau.clients && dataBureau.clients.length > 0 && (
                                    <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                                      {exportBureauClientsToExcel(dataBureau, `Ruta dibujada ${drawedRoute._id + 1}`, dataBureau.bureau_description)}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </GridItem>
                  );
                })}
                {selectedRoutes.map((selectedRoute) => {
                  return (
                    <GridItem
                      key={selectedRoute.id}
                      xs={4}
                      style={{ padding: '30px', position: 'relative' }}
                    >
                      <div style={{ position: 'absolute', top: '25px', right: '20px' }}>
                        <RegularButton
                          justIcon
                          round
                          color="danger"
                          onClick={() => {
                            setSelectedRoutes((items) => {
                              const newRoutes = [...items];
                              const index = newRoutes.findIndex((r) => r.id === selectedRoute.id);
                              newRoutes.splice(index, 1);
                              return newRoutes;
                            });
                          }}
                        >
                          <Delete />
                        </RegularButton>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                        <h4>{selectedRoute.description}</h4>
                        <LayerColorIcon
                          layer={{ color: selectedRoute.color }}
                          style={{ marginLeft: '10px' }}
                        />
                      </div>

                      <span>N° Pedidos</span>
                      <p>{selectedRoute.data?.total_pedidos}</p>

                      <span>N° Clientes</span>
                      <p>{selectedRoute.data?.total_clientes}</p>

                      <span>Monto S/.</span>
                      <p>S/. {parseFloat(selectedRoute.data?.total_migrate).toFixed(2)}</p>

                      <div>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
                          <thead>
                            <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
                              <th style={{ padding: '8px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>#</th>
                              <th style={{ padding: '8px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>Mesa</th>
                              <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>N° Pedidos</th>
                              <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>N° Clientes</th>
                              <th style={{ padding: '8px', textAlign: 'right', fontSize: '12px', fontWeight: 'bold' }}>Monto S/.</th>
                              <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>Exportar</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedRoute.data_bureau.map((dataBureau, index) => (
                              <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                <td style={{ padding: '8px', textAlign: 'left', fontSize: '12px' }}>{index + 1}</td>
                                <td style={{ padding: '8px', textAlign: 'left', fontSize: '12px' }}>{dataBureau.bureau_description}</td>
                                <td style={{ padding: '8px', textAlign: 'center', fontSize: '12px' }}>{dataBureau.total_pedidos}</td>
                                <td style={{ padding: '8px', textAlign: 'center', fontSize: '12px' }}>{dataBureau.total_clientes}</td>
                                <td style={{ padding: '8px', textAlign: 'right', fontSize: '12px' }}>S/. {parseFloat(dataBureau.total_migrate).toFixed(2)}</td>
                                <td style={{ padding: '8px', textAlign: 'center' }}>
                                  {dataBureau.clients && dataBureau.clients.length > 0 && (
                                    <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                                      {exportBureauClientsToExcel(dataBureau, selectedRoute.description, dataBureau.bureau_description)}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </GridItem>
                  );
                })}
                {showMonthlyBreakdown && shouldShowDetailedCards && selectedRoutes.length > 0 && (
                  <GridContainer>
                    {drawedPolygons.map((route, rIdx) => {
                      const dataKeys = Object.keys(route).filter((k) => 
                        /^data\d{4}/.test(k) && route[k] && !k.includes('bureau')
                      );
                      dataKeys.sort((a, b) => a.localeCompare(b));
                      
                      return dataKeys.map((dKey) => {
                        const suffix = dKey.replace('data', '');
                        const bureauKey = 'data_bureau' + suffix;
                        const dataObj = route[dKey] || {};
                        const bureauList = route[bureauKey] || [];

                        let displayTitle = `Ruta dibujada ${route._id + 1}`;
                        const yearMatch = suffix.match(/^(\d{4})(.*)$/);
                        if (yearMatch) {
                          const year = yearMatch[1];
                          const monthAbbr = yearMatch[2];
                          displayTitle = `Ruta dibujada ${route._id + 1} - ${monthAbbr} ${year}`;
                        }
                        
                        return (
                          <GridItem 
                            key={`drawed-${rIdx}-${dKey}`} 
                            xs={12} 
                            md={4} 
                            lg={4} 
                            style={{ padding: '30px', position: 'relative' }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '2px', marginBottom: '15px' }}>
                              <h4>{displayTitle}</h4>
                              <LayerColorIcon
                                layer={{ color: '#ff5733' }}
                                style={{ marginLeft: '10px' }}
                              />
                            </div>

                            <span>N° Pedidos</span>
                            <p>{dataObj.total_pedidos || 0}</p>

                            <span>N° Clientes</span>
                            <p>{dataObj.total_clientes || 0}</p>

                            <span>Monto S/.</span>
                            <p>S/. {parseFloat(dataObj.total_migrate || 0).toFixed(2)}</p>

                            <div>
                              <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
                                <thead>
                                  <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
                                    <th style={{ padding: '8px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>#</th>
                                    <th style={{ padding: '8px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>Mesa</th>
                                    <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>N° Pedidos</th>
                                    <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>N° Clientes</th>
                                    <th style={{ padding: '8px', textAlign: 'right', fontSize: '12px', fontWeight: 'bold' }}>Monto S/.</th>
                                    <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>Exportar</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(bureauList || []).map((b, i) => (
                                    <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                      <td style={{ padding: '8px', textAlign: 'left', fontSize: '12px' }}>{i + 1}</td>
                                      <td style={{ padding: '8px', textAlign: 'left', fontSize: '12px' }}>{b.bureau_description || b.description || b.id}</td>
                                      <td style={{ padding: '8px', textAlign: 'center', fontSize: '12px' }}>{b.total_pedidos || 0}</td>
                                      <td style={{ padding: '8px', textAlign: 'center', fontSize: '12px' }}>{b.total_clientes || 0}</td>
                                      <td style={{ padding: '8px', textAlign: 'right', fontSize: '12px' }}>S/. {parseFloat(b.total_migrate || 0).toFixed(2)}</td>
                                      <td style={{ padding: '8px', textAlign: 'center' }}>
                                        {b.clients && b.clients.length > 0 && (
                                          <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                                            {exportBureauClientsToExcel(b, `Ruta dibujada ${route._id + 1}`, b.bureau_description || b.description, suffix)}
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </GridItem>
                        );
                      });
                    })}

                    {/* Tarjetas mensuales para rutas seleccionadas */}
                    {selectedRoutes.map((route, rIdx) => {
                      const dataKeys = Object.keys(route).filter((k) => 
                        /^data\d{4}/.test(k) && route[k] && !k.includes('bureau')
                      );
                      dataKeys.sort((a, b) => a.localeCompare(b));
                      
                      return dataKeys.map((dKey) => {
                        const suffix = dKey.replace('data', '');
                        const bureauKey = 'data_bureau' + suffix;
                        const dataObj = route[dKey] || {};
                        const bureauList = route[bureauKey] || [];

                        let displayTitle = route.description;
                        const yearMatch = suffix.match(/^(\d{4})(.*)$/);
                        if (yearMatch) {
                          const year = yearMatch[1];
                          const monthAbbr = yearMatch[2];
                          displayTitle = `${route.description} - ${monthAbbr} ${year}`;
                        }
                        
                        return (
                          <GridItem 
                            key={`${rIdx}-${dKey}`} 
                            xs={12} 
                            md={4} 
                            lg={4} 
                            style={{ padding: '30px', position: 'relative' }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '2px', marginBottom: '15px' }}>
                              <h4>{displayTitle}</h4>
                              <LayerColorIcon
                                layer={{ color: route.color }}
                                style={{ marginLeft: '10px' }}
                              />
                            </div>

                            <span>N° Pedidos</span>
                            <p>{dataObj.total_pedidos || 0}</p>

                            <span>N° Clientes</span>
                            <p>{dataObj.total_clientes || 0}</p>

                            <span>Monto S/.</span>
                            <p>S/. {parseFloat(dataObj.total_migrate || 0).toFixed(2)}</p>

                            <div>
                              <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
                                <thead>
                                  <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
                                    <th style={{ padding: '8px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>#</th>
                                    <th style={{ padding: '8px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }}>Mesa</th>
                                    <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>N° Pedidos</th>
                                    <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>N° Clientes</th>
                                    <th style={{ padding: '8px', textAlign: 'right', fontSize: '12px', fontWeight: 'bold' }}>Monto S/.</th>
                                    <th style={{ padding: '8px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }}>Exportar</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(bureauList || []).map((b, i) => (
                                    <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                      <td style={{ padding: '8px', textAlign: 'left', fontSize: '12px' }}>{i + 1}</td>
                                      <td style={{ padding: '8px', textAlign: 'left', fontSize: '12px' }}>{b.bureau_description || b.description || b.id}</td>
                                      <td style={{ padding: '8px', textAlign: 'center', fontSize: '12px' }}>{b.total_pedidos || 0}</td>
                                      <td style={{ padding: '8px', textAlign: 'center', fontSize: '12px' }}>{b.total_clientes || 0}</td>
                                      <td style={{ padding: '8px', textAlign: 'right', fontSize: '12px' }}>S/. {parseFloat(b.total_migrate || 0).toFixed(2)}</td>
                                      <td style={{ padding: '8px', textAlign: 'center' }}>
                                        {b.clients && b.clients.length > 0 && (
                                          <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                                            {exportBureauClientsToExcel(b, route.description, b.bureau_description || b.description, suffix)}
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </GridItem>
                        );
                      });
                    })}
                  </GridContainer>
                )}
                
              </GridContainer>
                </>
              )}
          </GridItem>
        </GridContainer>
      </CardContainer>
    </Fragment>
  );
}

export { RouteSales };
